/**
 *
 * @module gender
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef Gender
 * @type {Object}
 * @desc Specifies the gender assigned to the account.
 * @example Gender.female // 'female'
 *
 * @property {String} female
 * @property {String} male
 * @property {String} unspecified
 *
 */

/**
 *
 * @enum
 * @type {Gender}
 *
 */
export default KeyMirror({
    /**
     *
     * @type {String}
     *
     */
    female: null,
    /**
     *
     * @type {String}
     *
     */
    male: null,
    /**
     *
     * @type {String}
     *
     */
    unspecified: null
});



// WEBPACK FOOTER //
// ./src/account/gender.js